// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"bec2c696","630":"bdda5d57","673":"f947ce93","741":"f431e751","774":"ed4df70d","787":"57f25232","802":"1ac79f7a","883":"8256b30c","901":"4d7874dd","943":"4141a998"}[chunkId] + ".chunk.js";
};